import React from 'react'
import Instagramimg from "./instagram.png"

export default function Instagram() {
  return (
    <img src={Instagramimg} width="20px" height="20px"></img>
  )
}

